// Constants
export const USER_LOADING = 'USER_LOADING';
export const USER_FULFILLED = 'USER_FULFILLED';
export const USER_LIST_FULFILLED = 'USER_LIST_FULFILLED';
export const ADDRESS_FULFILLED = 'ADDRESS_FULFILLED';
